export default {
    mapper: {
        relations: [],
    },
};
